// project import
import dashboard from './dashboard';
import quanlykhachhang from './menu-quanly';
import nhapxuat from './menu-nhapxuat';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard,nhapxuat, quanlykhachhang]
};

export default menuItems;
